
  import {defineComponent, reactive} from 'vue';
  import Footer from '@/components/footer.vue'

  export default defineComponent({
    name: "Teacher",
    components: {Footer},
    setup() {
      return reactive({
        form: {
          name: '',
          address: '',
          msg: ''
        }
      });
    },

    mounted() {
      this.$nextTick(() => {
        (this as any).pageBox = this.$refs['pageBox']
        console.log((this as any).pageBox);
        (this as any).pageBox.addEventListener('scroll', this.handleScroll, true);
      });
    },
    methods: {
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        console.log(scrollTop)
      },

      submitForm(formName: string) {
        (this as any).$refs[formName].validate((valid: any) => {
          if (valid) {
            console.log(this.form)
          }
        })
      }
    }

  })
